import Vue from 'vue'
import VueRouter from 'vue-router'
// const Home = () => import('@/pages/home/home')
import Home from '@/pages/home/home'
// const MeetTheTeam = () => import('@/pages/meet-the-team/meet-the-team')
import BracesAcademy from '@/pages/braces-academy/braces-academy'
import MeetTheTeam from '@/pages/meet-the-team/meet-the-team'
// const Services = () => import('@/pages/services/services')
import Services from '@/pages/services/services'
// const Invisalign = () => import('@/pages/invisalign/invisalign')
import Invisalign from '@/pages/invisalign/invisalign'
// const Patient = () => import('@/pages/patient/patient')
import Patient from '@/pages/patient/patient'
// const ApplianceTypes = () => import('@/pages/appliance-types/appliance-types')
import ApplianceTypes from '@/pages/appliance-types/appliance-types'
// const Contact = () => import('@/pages/contact/contact')
import Contact from '@/pages/contact/contact'
import Events from '@/pages/events/events'
import Accessibility from '@/pages/accessibility/accessibility'
import PrivacyPolicy from '@/pages/privacy-policy/privacy-policy'
// const PageNotFound = () => import('@/pages/404/404')
// import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      navigation: false,
      meta: false
    },
    {
      path: '/meet-the-team',
      name: 'meet the team',
      component: MeetTheTeam,
      navigation: true,
      meta: false
    },
    {
      path: '/braces-academy',
      name: 'patient videos',
      component: BracesAcademy,
      navigation: true,
      meta: false
    },
    {
      path: '/services',
      name: 'services',
      component: Services,
      navigation: true,
      meta: false
    },
    {
      path: '/invisalign',
      name: 'invisalign',
      component: Invisalign,
      navigation: true,
      meta: false
    },
    {
      path: '/patient',
      name: 'patients',
      component: Patient,
      navigation: true,
      meta: false
    },
    {
      path: '/appliance-types',
      name: 'appliance types',
      component: ApplianceTypes,
      navigation: true,
      meta: false
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      navigation: false,
      meta: false
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      navigation: true,
      meta: false
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      component: Accessibility,
      navigation: false,
      meta: false
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicy,
      navigation: false,
      meta: false
    },
    {
      path: '/*',
      name: 'redirect',
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js